import { defineStore } from "pinia";
import { ref } from "vue";
import { findCategoryList } from "@/apis/category.js";

export const useCategoryStore = defineStore("category", () => {
  //state
  const categoryList = ref([]);
  // 分类路由菜单导航
  const categoryMenu = ref([]);

  async function setCategoryList() {
    try {
      const { data } = await findCategoryList();
      categoryList.value = data;
    } catch (error) {}
  }

  async function setCategoryMenu(menu) {
    console.log("🚀 ~ setCategoryMenu ~ menu:", menu)
    categoryMenu.value = menu;
  }

  return {
    categoryList,
    setCategoryList,
    categoryMenu,
    setCategoryMenu,
  };
},{
    persist: true,
});
